import Component, { mixins } from "vue-class-component";
import { ApplicationUserRoleMixin } from "@/mixins";

@Component
export class GroupUserRoleMixin extends mixins(ApplicationUserRoleMixin) {
    async mounted(): Promise<void> {
        await this.$store.dispatch("group/loadValidators", this.application.code);
    }
}
